<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Company information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="General"></el-step>
                  <el-step title="Representives"></el-step>
                  <el-step title="Beneficial Owners"></el-step>
                  <el-step title="Documentation"></el-step>
                  <el-step title="Banking Info"></el-step>
                  <el-step title="Questionnaire"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-10 col-lg-10"
              style="margin-left: 10%; margin-top: 40px"
            >
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-col :span="24">
                  <el-row>
                    <el-col :span="22">
                      <h3>
                        <span slot="label"> Upload documents </span>
                      </h3>
                      <p style="color: #999; margin: 10px 0 10px 0">
                        Please upload all the requested documentations.All
                        documents uploaded need to be in English or include
                        English translation
                      </p>
                      <br />
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="Certificate of Incorporation and Business Registration"
                    label-width="0"
                    prop="s4_com_id_file"
                    required
                  >
                    <FileUpload
                      emitaction="set_s4_com_id_file_url"
                      :fileurl="formData.s4_com_id_file"
                      v-on:emitaction="set_s4_com_id_file_url"
                    ></FileUpload>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="Current Limited Partnership Agreement, Operating Agreement, Bylaws, Article of Incorporation, or equivalent."
                    label-width="0"
                    prop="s4_com_desc_file"
                    required
                  >
                    <FileUpload
                      emitaction="set_s4_com_desc_file_url"
                      :fileurl="formData.s4_com_desc_file"
                      v-on:emitaction="set_s4_com_desc_file_url"
                    ></FileUpload>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="Ownership Organizational Chart"
                    label-width="0"
                    prop="s4_org_chart_file"
                    required
                  >
                    <p style="color: #999; margin-bottom: 20px">
                      List or draw a diagram for the individual(s) who directly
                      or indirectly, through any contract, arrangement,
                      understanding, relationship or otherwise, owns or controls
                      25% (10% for Money Services Businesses) or more of the
                      equity interests of the Institution, including their
                      ownership or control percentage.
                    </p>

                    <FileUpload
                      emitaction="set_s4_org_chart_file_url"
                      :fileurl="formData.s4_org_chart_file"
                      v-on:emitaction="set_s4_org_chart_file_url"
                    ></FileUpload>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="Proof of Address"
                    label-width="0"
                    prop="s4_proof_file"
                    required
                  >
                    <p style="color: #999; margin-bottom: 20px">
                      Utility bill, bank statement, cable/internet bill, rent
                      invoice. We don't accept PO Box.
                    </p>

                    <FileUpload
                      emitaction="set_s4_proof_file_url"
                      :fileurl="formData.s4_proof_file"
                      v-on:emitaction="set_s4_proof_file_url"
                    ></FileUpload>
                  </el-form-item>
                </el-col>
                <el-form-item
                  label="Are you a regulated financial institution with a BSA/AML program?（YES/NO)"
                  prop="politicalFigure"
                >
                  <el-radio-group
                    v-model="formData.s4_is_aml_program"
                    size="medium"
                  >
                    <el-radio
                      v-for="(item, index) in yesOrNoOptions()"
                      :key="index"
                      :label="item.value"
                      :disabled="item.disabled"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-col :span="24" v-if="formData.s4_is_aml_program == '1'">
                  <el-form-item
                    label="BSA/AML Policy"
                    label-width="0"
                    prop="s4_aml_policy_file"
                    :required="formData.s4_is_aml_program == '1'"
                  >
                    <p style="color: #999; margin-bottom: 20px">
                      If Yes for the previous question, please provide your
                      BSA/AML and Sanctions Policy document.
                    </p>

                    <FileUpload
                      emitaction="set_s4_aml_policy_file_url"
                      :fileurl="formData.s4_aml_policy_file"
                      v-on:emitaction="set_s4_aml_policy_file_url"
                    ></FileUpload>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="6" :offset="0" style="margin-top: 40px"
                  ><el-button @click="goback">Previous</el-button></el-col
                > -->
                <el-col :span="24" :offset="10">
                  <el-form-item size="large">
                    <el-button type="primary" @click="submitForm"
                      >Submit</el-button
                    >
                    <el-button @click="resetForm">Reset</el-button>
                  </el-form-item></el-col
                >
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import FileUpload from "../../components/plugins/FileUpload2.vue";
import {
  otc_auth_status,
  get_info,
  att_info,
} from "../../plugins/api/account_otc";
import { yesOrNoOptions } from "../../plugins/data/form_base_data";
export default {
  components: { FileUpload },
  props: [],
  data() {
    return {
      activeStep: 3,
      formData: {
        process: 4,
        s4_is_aml_program: "",
      },
      rules: {
        s4_com_id_file: [
          {
            required: true,
            message: "Certificate of Incorporation and Business Registration",
            trigger: "change",
          },
        ],
        s4_com_desc_file: [
          {
            required: true,
            message:
              "Current Limited Partnership Agreement, Operating Agreement, Bylaws, Article of Incorporation, or equivalent",
            trigger: "change",
          },
        ],
        s4_org_chart_file: [
          {
            required: true,
            message: "Ownership Organizational Chart",
            trigger: "blur",
          },
        ],
        s4_proof_file: [
          {
            required: true,
            message: "Proof of Address",
            trigger: "blur",
          },
        ],
        s4_aml_policy_file: [
          {
            required: true,
            message: "BSA/AML Policy",
            trigger: "blur",
          },
        ],
        additionalInfo: [
          {
            required: true,
            message:
              "The assets that you are interested to buy/sell and the estimated amount per month",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      console.log(res);
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    // get_additional_info().then((res_query) => {
    //   if (res_query.data.usSanctions) {
    //     this.$Message.success("This information has been stored");
    //     this.formData = res_query.data;
    //   }
    // });
    get_info(
      `/account_otc/get_company_info?process=${this.formData.process}`
    ).then((res_query) => {
      if (res_query.data) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
        this.formData.s4_is_aml_program = `${this.formData.s4_is_aml_program}`;
      } else {
      }
    });
  },
  mounted() {},
  methods: {
    set_s4_com_id_file_url(url) {
      this.formData.s4_com_id_file = url;
    },
    set_s4_com_desc_file_url(url) {
      this.formData.s4_com_desc_file = url;
    },
    set_s4_org_chart_file_url(url) {
      this.formData.s4_org_chart_file = url;
    },
    set_s4_proof_file_url(url) {
      this.formData.s4_proof_file = url;
    },
    set_s4_aml_policy_file_url(url) {
      this.formData.s4_aml_policy_file = url;
    },
    yesOrNoOptions() {
      return yesOrNoOptions;
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        this.formData.process = 4;
        att_info("/account_otc/att_company_info", this.formData).then((res) => {
          if (res.code == 0 || res.code == 18289475) {
            this.$router.push("/reg/inc_cert/step5");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    goback() {
      this.$router.push("/reg/inc_cert/step3");
    },
  },
};
</script>
<style scoped>
.uu-add-img input {
  left: 10% !important;
}
</style>
